import {ASTKindToNode, ASTNode} from 'graphql/language/ast';

export function getASTNodesOfKind<K extends keyof ASTKindToNode>(
  nodes: ReadonlyArray<ASTNode>,
  kind: K
): ReadonlyArray<ASTKindToNode[K]> {
  return nodes.filter((node) => node.kind === kind) as Array<ASTKindToNode[K]>;
}

export function getSingleASTNodeOfKind<K extends keyof ASTKindToNode>(
  nodes: ReadonlyArray<ASTNode>,
  kind: K
): ASTKindToNode[K] {
  const matching = getASTNodesOfKind(nodes, kind);
  if (matching.length !== 1) {
    throw new Error(`Expected single node of kind=${kind}`);
  }
  return matching[0];
}
